import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

export class GetOpenReviewEntryListUseCase {
  constructor(private reviewEntryRepository: ReviewEntryRepository) {}

  async getByUserIdAndProblemIdOpenEntries(userId: string, problemId: string): Promise<ReviewEntry[]> {
    try {
      return await this.reviewEntryRepository.getByUserIdAndProblemIdOpenEntries(userId, problemId)
    } catch (error) {
      console.error(`Error in GetOpenReviewEntryListUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
